import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from "react-router-dom";

const MetaTags = ({ title, description, keywords }) => {
  const location = useLocation();

  const baseUrl = "https://www.positivemetering.ae";
  const canonicalUrl = `${baseUrl}${location.pathname}`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="robots" content="index,follow" />
      <meta property="og:url" content={canonicalUrl} />
    </Helmet>
  );
};

export default MetaTags;
